(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/envelope/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/components/tur/envelope/assets/javascripts/index.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const _svs$tur$envelope$com = svs.tur.envelope.components,
  ContentImages = _svs$tur$envelope$com.ContentImages,
  ConcaveShadow = _svs$tur$envelope$com.ConcaveShadow;

const Envelope = _ref => {
  let branding = _ref.branding,
    _ref$bodyColor = _ref.bodyColor,
    bodyColor = _ref$bodyColor === void 0 ? 'white' : _ref$bodyColor,
    children = _ref.children,
    className = _ref.className,
    content = _ref.content,
    image = _ref.image,
    repeatImage = _ref.repeatImage,
    images = _ref.images,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$split = _ref.split,
    split = _ref$split === void 0 ? false : _ref$split,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? 'envelope-test-id' : _ref$dataTestId;
  const bodyRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showConcave = _useState2[0],
    setShowConcave = _useState2[1];
  let repeatedImages;
  if (repeatImage > 1 && image) {
    repeatedImages = Array.from({
      length: repeatImage
    }, () => image);
  }
  const contentImages = repeatedImages || images || image && [image];
  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.style.setProperty('--bgColor', bodyColor);
      setShowConcave(true);
    }
  }, [bodyColor]);
  return React.createElement("div", {
    className: "envelope elevation-100".concat(branding === 'triss' ? ' branding-triss' : '', " ").concat(className ? className : ''),
    "data-testid": dataTestId,
    style: style
  }, React.createElement("div", {
    className: "envelope-lid"
  }), contentImages && contentImages.length && React.createElement(ContentImages, {
    images: contentImages,
    split: split
  }), content, showConcave && React.createElement(ConcaveShadow, {
    fillColor: bodyColor,
    parentRef: bodyRef
  }), React.createElement("div", {
    className: "envelope-body",
    ref: bodyRef
  }, children));
};
setGlobal('svs.tur.Envelope', Envelope);

 })(window);